import { forwardRef } from 'react';
import LinkInternal from './link-internal';
const Link = forwardRef(LinkInternal);
export default Link;
